var target = document.querySelector('body');
var config = { childList: true, subtree: true };

var callback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.addedNodes.length && mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('osf_dialog')) {
            var button = document.createElement('button');
            button.textContent = 'Poursuivre les achats';
            button.classList.add('osf_continue_button');
            button.classList.add('button');
            document.querySelector('.osf_popup_body').appendChild(button);
            button.addEventListener('click', function() {
                document.querySelector('.osf_close_button').click();
            });
            // remove observer
            observer.disconnect();
        }
    }
}

var observer = new MutationObserver(callback);
observer.observe(target, config);